/*
 * Copyright (c) CIRROM 2025.
 */

import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { rgba } from "polished";

import { Box, Typography as MuiTypography } from "@mui/material";
import { spacing } from "@mui/system";
import { MiraTheme } from "../../theme/theme";
import {
  RelativeCardContent,
  RelativeAnimatedClickableCard,
} from "../common/Card";
import { NUMBER_FORMATTER } from "../../../utils/utils";
import { useNavigate } from "react-router-dom";

const Typography = styled(MuiTypography)(spacing);

const illustrationPercentageStyle = (props: any) => css`
  ${props.illustration &&
  props.theme.palette.mode !== "dark" &&
  `
    color: ${rgba(props.theme.palette.primary.main, 0.85)};
  `}
`;

const Percentage = styled(MuiTypography)<{
  percentagecolor: string;
  illustration?: string;
  theme?: MiraTheme;
}>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  span {
    color: ${(props) => props.percentagecolor};
    background: ${(props) => rgba(props.percentagecolor, 0.1)};
    padding: 2px;
    border-radius: 3px;
    margin-right: ${(props) => props.theme.spacing(2)};
  }

  ${illustrationPercentageStyle}
`;

type StatsProps = {
  title: string;
  amount: number;

  percentageText: string;
  percentageColor: string;
  clickPath?: string;
};

export const Stats: React.FC<StatsProps> = ({
  title,
  amount,
  percentageText,
  percentageColor,
  clickPath,
}) => {
  const navigate = useNavigate();
  return (
    <RelativeAnimatedClickableCard
      onClick={() => clickPath && navigate(clickPath)}
    >
      <RelativeCardContent>
        <Typography variant="h6" mb={6}>
          {title}
        </Typography>
        <Typography variant="h3" mb={6}>
          <Box fontWeight="fontWeightRegular">
            {NUMBER_FORMATTER.format(amount)}
          </Box>
        </Typography>
        {percentageText && percentageColor && (
          <Percentage
            variant="subtitle2"
            color="textSecondary"
            percentagecolor={percentageColor}
          >
            <span>{percentageText}</span> Since last week
          </Percentage>
        )}
      </RelativeCardContent>
    </RelativeAnimatedClickableCard>
  );
};
